export default "__VITE_ASSET__ad4b2892__"